import SberTabs from '../../components/other/SberTabs/SberTabs';
import './main.scss';

(function () {
    console.log(111, 'main init');
})();
